module.exports = __webpack_public_path__ + "media/images/official/about_yamori_zushi-c66431338661019be9c43703f935d546.png";